// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__tgNWB","contained":"OpenButton_contained__3JK4q","disabled":"OpenButton_disabled__b6qJ3","error":"OpenButton_error__uOOv_"};